import { z } from 'zod';
import { BaseSchema } from './baseSchema';

const ImageSchema = z.object({
    image: z.string(),
    footprint: z.string().nullable().optional(),
});

export const BasicPageSchema = BaseSchema.extend({
    title: z.string(),
    abstract: z.string().nullable().optional(),
    body: z.string().nullable().optional(),
});

export const LearnMoreSchema = BasicPageSchema.extend({
    uri: z.string().nullable().optional(),
    bibliography_data: z.array(
        z.object({
            ref_publications_title: z.string(),
            ref_publications_authors: z.string().nullable().optional(),
            ref_publications_date: z.string().nullable().optional(),
            ref_publications_typology: z.string().nullable().optional(),
        })
    ),
});

export const ChapterSchema = BaseSchema.extend({
    title: z.string(),
    abstract: z.string().nullable().optional(),
    body: z.string(),
    image: z.array(ImageSchema).nullable().optional(),
    other_images: z.array(ImageSchema).nullable().optional(),
    audiovisual: z.array(
        z.object({
            title: z.string(),
            video: z.string(),
        })
    ),
    indexations: z.string().nullable().optional(),
    pdf_data: z.array(
        z.object({
            document: z.string(),
            title: z.string(),
        })
    ),
});

export const TimelineYearsSchema = BaseSchema.extend({
    title: z.string(),
    term: z.string(),
    abstract: z.string(),
    related: z.string().nullable().optional(),
});
